module.exports = __webpack_public_path__ + "img/3.c00c848f.png";